import { withTranslation } from 'react-i18next'
import { useRef, useState } from 'react'
import { inject, observer } from 'mobx-react'
import { SideBarSection } from '../../common/SideBarContainer'
import { DragDropProvider } from '@dnd-kit/react'
import Icon from '../../common/Icon'
import Button from '../../common/Button'
import Sortable from './Sortable'
import Popover from '../../common/Popover'
import { uniqueId } from 'lodash'
import { FieldTypeOptions } from './FieldTypeSelect'
import { selectionTypes } from '../../../constants'

const AdditionalInformation = ({ selectionStore, dataStore }) => {
  const [open, setOpen] = useState(false)
  const listRef = useRef(null)
  const item = selectionStore.item ? selectionStore.item : null
  if (!item) return null
  if (!item.type === selectionTypes.ZIP_CODE_BOUNDARY &&
      !item.type === selectionTypes.BOUNDARY && !item.type === selectionTypes.GEOPOLYGON &&
      !item.type === selectionTypes.TARGET_GROUP && item.type === selectionTypes.MARKER) return null

  return (
    <SideBarSection title='Additional Information'>
      <div>
        <DragDropProvider
          onDragEnd={(event) => {
            dataStore.sortUserAdditionalInfoItems(event)
          }}
        >
          <ul
            ref={listRef}
            className='sortable_list'
          >
            {dataStore.userAdditionalInfoItems.map((info_item, index) => (
              <Sortable
                key={info_item.id}
                id={info_item.id}
                index={index}
                item={info_item}
                typeSelectable={false}
              />
            ))}
          </ul>
        </DragDropProvider>
      </div>
      <Popover open={open} onOpenChange={setOpen}>
        <Popover.Trigger asChild>
          <div
            style={{ color: '#2F7D8A', cursor: 'pointer' }}
          >
            <span><Icon id='fa-add' style={{ fontWeight: 200 }} /></span> Add field
          </div>
        </Popover.Trigger>
        <Popover.Content>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div style={{ fontFamily: 'Inter, sans-serif', fontSize: '12px', color: '#292C44', fontWeight: 600 }}>
              Choose field type
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly' }}>
              {FieldTypeOptions.map((option, index) => (
                <div key={index} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 4 }}>
                  <Button
                    variant='outline' size='icon' style={{ borderRadius: '6px', background: '#F6F7F9', color: '#3D4058' }}
                    onClick={() => {
                      const len = item ? item.additional_info.length : 0
                      const id = uniqueId(item.id + len)
                      const infoItem = {
                        id,
                        label: option.label,
                        type: option.type,
                        input: option.input,
                        order: len + 1,
                        type_selectable: true,
                      }
                      dataStore.saveUserAdditionalInfoItem(infoItem)
                      setOpen(false)
                    }}
                  >
                    {option.icon}
                  </Button>
                  <label style={{ fontSize: '11px', fontWeight: 500, color: '#3D4058', fontFamily: 'Inter, sans-serif' }}>
                    {option.label}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </Popover.Content>
      </Popover>
    </SideBarSection>
  )
}

export default withTranslation()(
  inject('selectionStore', 'dataStore')(observer(AdditionalInformation))
)
